/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class GcpBigQueryResourceViewsInner {
  /**
  * View name.
  */
  'name'?: string;
  /**
  * View type.
  */
  'type'?: string;
  /**
  * View creation time.
  */
  'creationTime'?: Date;
  /**
  * View last modification time.
  */
  'lastModifiedTime'?: Date;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "type",
      "baseName": "type",
      "type": "string",
      "format": ""
    },
    {
      "name": "creationTime",
      "baseName": "creationTime",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "lastModifiedTime",
      "baseName": "lastModifiedTime",
      "type": "Date",
      "format": "date-time"
    }  ];

  static getAttributeTypeMap() {
    return GcpBigQueryResourceViewsInner.attributeTypeMap;
  }

  public constructor() {
  }
}

